// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/core-js/modules/_iobject.js
// module id = ../../../../core-js/modules/_iobject.js
// module chunks = 0